var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5C16.8655 4.5 18.5853 5.04331 19.8576 5.95937C21.1288 6.87462 22 8.20495 22 9.75C22 10.7344 21.6441 11.6369 21.0557 12.3972L21.9013 13.8781C22.0338 14.1102 22.0328 14.3954 21.8986 14.6265C21.7644 14.8577 21.5173 15 21.25 15H15C13.1345 15 11.4147 14.4567 10.1424 13.5406C8.87117 12.6254 8 11.2951 8 9.75C8 8.20495 8.87117 6.87462 10.1424 5.95937C11.4147 5.04331 13.1345 4.5 15 4.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 16.4995H15.3334C14.9618 17.0906 14.4537 17.611 13.8576 18.0402C12.5853 18.9562 10.8655 19.4995 9 19.4995H2.75C2.48269 19.4995 2.23558 19.3573 2.10137 19.1261C1.96717 18.8949 1.96615 18.6098 2.09871 18.3776L2.94435 16.8967C2.3559 16.1365 2 15.2339 2 14.2495C2 12.7045 2.87117 11.3742 4.14235 10.4589C4.82115 9.97018 5.62733 9.58755 6.51505 9.33691C6.5051 9.4727 6.5 9.61026 6.5 9.74954C6.5 11.8994 7.71441 13.6404 9.2659 14.7575C10.8207 15.877 12.8553 16.4995 15 16.4995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoMessage);
export default __webpack_public_path__ + "static/media/DuoMessage.e1f5f893369d7ad2057a9751a86b909e.svg";
export { ForwardRef as ReactComponent };